import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

interface InstallEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

export function InstallPrompt() {
  const [event, setEvent] = useState<InstallEvent>();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("install_prompt_hidden") === "1");
  useEffect(() => {
    const listener = (incoming: Event) => { incoming.preventDefault(); setEvent(incoming as InstallEvent); };
    window.addEventListener("beforeinstallprompt", listener);
    return () => window.removeEventListener("beforeinstallprompt", listener);
  }, []);
  if (!event || hidden) return null;
  const install = async () => { await event.prompt(); const result = await event.userChoice; if (result.outcome === "accepted") setHidden(true); };
  const dismiss = () => { sessionStorage.setItem("install_prompt_hidden", "1"); setHidden(true); };
  return <aside className="install-prompt"><span><Download size={20} /></span><div><strong>Instalar WG Estoque</strong><small>Acesso mais rápido e funcionamento offline.</small></div><button className="secondary-button" onClick={install}>Instalar</button><button className="icon-button" onClick={dismiss} aria-label="Fechar"><X size={17} /></button></aside>;
}
